/*
 * Deprecated
 * Please use src/composables/table-helpers/useMemoDefaultColumnSizing.ts
 */

import { ref, watch } from "vue";
import { useCookies } from "@vueuse/integrations/useCookies";

export const useMemoColumnSizing = (
  key: string,
  defaultColumnSizing: Record<string, number>,
) => {
  const cookies = useCookies();
  const columnSizingFromCookies = cookies.get(key);

  const columnSizing = ref(columnSizingFromCookies ?? defaultColumnSizing);

  const memoizeColumnSizing = () => {
    cookies.set(key, columnSizing.value);
  };

  watch(
    () => columnSizing.value,
    () => memoizeColumnSizing(),
  );

  return {
    columnSizing,
  };
};

export default {};
